module.exports = __webpack_public_path__ + "static/media/saved.39c91dd1.svg";